import useSWR from 'swr';

export const useCompanies = () => {
  const { data: companies, error, isLoading, mutate } = useSWR('/companies');

  return {
    companies,
    error,
    isLoading,
    mutate,
  };
};
